import { useSelector } from 'react-redux';
import { B2xUserAccountType } from 'src/redux/reducers/mainReducer';
import { RootState } from 'src/redux/reducers/rootReducer';
import { useEnv } from './useEnv';

export const useUpgradeAccountStatus = () => {
  const accountType = useSelector(
    (state: RootState) => state.main.b2xUser.account_type,
  );

  const { isProdEnv } = useEnv();

  const isNotSubmitted = [
    B2xUserAccountType.NOT_SUBMITTED,
    B2xUserAccountType.SUBMITTING,
  ].includes(accountType);

  const isSubmitted = [
    B2xUserAccountType.SUBMITTED,
    B2xUserAccountType.RESUBMITTED,
    B2xUserAccountType.REVIEWED,
  ].includes(accountType);

  const isNeedRevision =
    accountType === B2xUserAccountType.NEED_REVISION ||
    accountType === B2xUserAccountType.TEMPORARILY_SUSPEND;

  const isProdApproved = accountType === B2xUserAccountType.APPROVED;

  // accountType in staging env is always marked as APPROVED
  const isApproved = isProdEnv ? isProdApproved : true;

  const isBlocked = [
    B2xUserAccountType.REJECTED,
    B2xUserAccountType.BLOCKED,
  ].includes(accountType);

  const isRejected = accountType === B2xUserAccountType.REJECTED;

  const shouldSubmit = [
    B2xUserAccountType.NOT_SUBMITTED,
    B2xUserAccountType.SUBMITTING,
    B2xUserAccountType.NEED_REVISION,
    B2xUserAccountType.TEMPORARILY_SUSPEND,
  ].includes(accountType);

  return {
    accountType,
    isApproved,
    isBlocked,
    isNeedRevision,
    isNotSubmitted,
    isProdApproved,
    isSubmitted,
    isRejected,
    shouldSubmit,
  };
};
